import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui';
import { Logo } from '@/components/layout/Logo';

export function NotFoundPage() {
  const { t } = useLanguage();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-6 text-center">
      <Logo size={56} />
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-muted text-ink-subtle">
        <Compass className="h-7 w-7" aria-hidden />
      </div>
      <div className="max-w-md space-y-2">
        <h1 className="font-display text-2xl font-bold text-ink">{t('errors.notFound')}</h1>
        <p className="text-sm text-ink-muted">{t('errors.notFoundBody')}</p>
      </div>
      <Link to="/dashboard">
        <Button>{t('errors.backHome')}</Button>
      </Link>
    </div>
  );
}
